import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import {getEventId, isDateTbd, isEnded, isStarted, isStartingToday} from '@wix/wix-events-commons-statics'
import {State} from '../types/state'
import {getFirstEvent} from './events'
import {isCalendarLayout} from './list-settings'
import {getComponentConfig} from './settings'

export const isItemOpened = (state: State, eventId: string) => state.layout.listItemOpened === eventId

export const getForcedRibbon = (state: State) => state.layout.forceShowRibbon

export const getForcedEventBadge = (state: State) => state.layout.forcedEventBadge

export const shouldForceShowRibbon = (state: State, event: wix.events.Event | Event_V3) => {
  const firstEvent = getFirstEvent(state)
  const firstEventId = firstEvent ? getEventId(firstEvent) : undefined
  return !!getForcedRibbon(state) && (firstEventId === getEventId(event) || isCalendarLayout(getComponentConfig(state)))
}

export const shouldShowCountdown = (event: wix.events.Event | Event_V3) =>
  !isEnded(event) && !isDateTbd(event) && !isStartingToday(event) && !isStarted(event)
